import Tooltip from 'bootstrap/js/dist/tooltip';

class Tooltips {
  // in Bootstrap 5, tooltips are no longer attached to jQuery by default.
  // but are initialized via JavaScript,
  // so we need to initialize them manually.
  // eslint-disable-next-line class-methods-use-this
  init() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
      Tooltip.getOrCreateInstance(el);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  updateTitle(target, title) {
    const el = target instanceof Element ? target : target?.[0];
    if (!el || typeof title !== 'string') return;

    const existing = Tooltip.getInstance(el);
    if (!existing && el.getAttribute('data-bs-toggle') !== 'tooltip') return;

    if (existing) existing.dispose();
    el.setAttribute('data-bs-original-title', title);
    el.setAttribute('title', title);
    Tooltip.getOrCreateInstance(el).show();
  }
}

export default new Tooltips();
